import React, { type ComponentProps } from 'react'
import AboutThisTreeContent from '../../components/details/researcher-trees/AboutThisTreeContent'
import UploadReport from './UploadReport'

export default function SettingsPageAboutThisTreeWrapper({
  gedcomData,
}: ComponentProps<typeof AboutThisTreeContent>): JSX.Element {
  return (
    <>
      <AboutThisTreeContent gedcomData={gedcomData} />
      <UploadReport />
    </>
  )
}
